import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { InputSection, TextAreaWrapper, Wrapper } from '../Input/Input.styled'
import { TEXT_INPUT } from '../Input/constants'

const TextArea = ({
  label,
  size,
  onFocus,
  onBlur,
  onMouseEnter,
  onMouseLeave,
  onChange,
  id,
  disabled,
  value,
  className,
  placeholder,
  defaultValue,
  horizontal,
  onEnter
}) => {
  const [focus, setFocus] = useState(false)
  const handleFocus = (e) => {
    setFocus(true)
    onFocus && onFocus(e)
  }
  const handleBlur = (e) => {
    setFocus(false)
    onBlur && onBlur(e)
  }
  const handleKeyDown = (e) => {
    if (onEnter && e.key === 'Enter') {
      onEnter(e.currentTarget.value)
    }
  }
  return (
    <Wrapper className={className} horizontal={horizontal}>
      {label && <label className='make-ui-text-input-label'>{label}</label>}
      <InputSection
        size={size}
        className={`make-ui-text-input-wrapper ${
          focus ? `make-ui-text-input-wrapper-focus` : ''
        }`}
      >
        <TextAreaWrapper
          id={id}
          type='text'
          className='make-ui-text-input'
          size={size}
          value={value}
          onChange={onChange}
          placeholder={placeholder}
          defaultValue={defaultValue}
          onFocus={handleFocus}
          onBlur={handleBlur}
          disabled={disabled}
          onMouseEnter={onMouseEnter}
          onMouseLeave={onMouseLeave}
          onKeyDown={handleKeyDown}
        />
      </InputSection>
    </Wrapper>
  )
}

TextArea.propTypes = {
  label: PropTypes.string,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func,
  onMouseEnter: PropTypes.func,
  onMouseLeave: PropTypes.func,
  onChange: PropTypes.func,
  id: PropTypes.string,
  disabled: PropTypes.bool,
  value: PropTypes.any,
  className: PropTypes.string,
  placeholder: PropTypes.string,
  defaultValue: PropTypes.string,
  size: PropTypes.oneOf([
    TEXT_INPUT.SIZE.BIG,
    TEXT_INPUT.SIZE.SMALL,
    TEXT_INPUT.SIZE.DEFAULT
  ]),
  horizontal: PropTypes.bool,
  onEnter: PropTypes.func
}
TextArea.defaultProps = {
  label: '',
  size: TEXT_INPUT.SIZE.DEFAULT,
  id: '1',
  disabled: false,
  className: '',
  placeholder: '',
  defaultValue: '',
  horizontal: false,
  onEnter: () => {}
}

export default TextArea
